import React, { useEffect, useState } from "react";
import config, { getBasicAuthHeaders } from "utils/configAdapter";
import { connect } from "react-redux";
import * as Icons from "@ant-design/icons";
import { mask, getColumnSearchProps } from "utils/helpers";
import dayjs from "dayjs";
import "dayjs/locale/pt-br";
import customParseFormat from "dayjs/plugin/customParseFormat";
import Core from "../../../../class/Core.js";
import {
    Space,
    Row,
    Col,
    Form,
    Table,
    Button,
    Select,
    message,
    Divider,
    Typography,
    DatePicker,
    Spin,
    Card,
} from "antd";
import ptBR from "antd/es/date-picker/locale/pt_BR";

dayjs.extend(customParseFormat);
dayjs.locale("pt-br");

// Removed: const _initToken = localStorage.getItem("authUser")

const Adicionais = (props) => {
    const { Title, Text } = Typography;

    const { RangePicker } = DatePicker;
    const [loading, setLoading] = useState(false);
    const [dataSource, setDataSource] = useState([]);
    const [dataTotal, setDataTotal] = useState([]);
    const [dataTotalAdic, setDataTotalAdic] = useState([]);
    const [adic, setAdic] = useState([]);
    const [aderiu, setAderiu] = useState("sim");
    const [loadingExcel, setLoadingExcel] = useState(false);
    const [segmentos, setSegmentos] = useState([]);
    const [adicArr, setAdicArr] = useState([]);

    const [paramsEXCEL, setParamsEXCEL] = useState("");
    const [formValid, setFormValid] = useState(false);
    const [hasSearched, setHasSearched] = useState(false);

    const [form] = Form.useForm();
    const FormItem = Form.Item;
    const { Option } = Select;

    const getAdicList = async () => {
        try {
            let core = new Core();
            let user = core.getAuth();

            let params = "?usuario=" + user.key;
            let result = await fetch(
                config[process.env.NODE_ENV].url +
                    `/empresa/relatorios/helper/adicional_list${params}`,
                {
                    method: "GET",
                    headers: getBasicAuthHeaders(),
                },
            );

            if (!result.ok) {
                throw await result.json();
            }

            result = await result.json();

            if (result.content) {
                result = result.content.map((e, k) => {
                    return {
                        value: `${e.id_adic}`,
                        label: e.nome_adic,
                    };
                });

                // result.unshift(
                //     {
                //         value: '0',
                //         label: <b>Não Obtantes</b>,
                //     }
                // )
            }

            setAdic(result);
        } catch (e) {
            //mensagem de erro
            if (e.hasOwnProperty("message")) {
                message.error(e.message);
            } else {
                message.error("Erro em executar a chamada.");
            }
        }
    };

    useEffect(() => {
        getAdicList();
        inicialDates();

        // if(window.location.search){
        //     let URLparams = {}
        //     window.location.search.replace('?','').split('&').map(e => { e = e.split('='); Object.assign(URLparams,{ [e[0]]:e[1] }) })
        //     if(URLparams.adic){ URLparams.blto_adic = URLparams.adic }
        //     if(URLparams.s){ URLparams.empresa_pesquisa = URLparams.s }
        //     let params = { tipo:'sim', /*default*/ ...URLparams }
        //     form.setFieldsValue(params)
        //     if(Object.keys(URLparams).length) callSearchForm(params)
        // }
    }, []);

    const inicialDates = () => {
        let d = new Date();
        let dini = new Date(d.getFullYear(), d.getMonth(), 1);
        let dfim = new Date(dini.getFullYear(), dini.getMonth() + 1, 0);
        let params = {
            date: [dayjs(dini), dayjs(dfim)],
        };
        form.setFieldsValue(params);
    };

    const callSearchForm = async (data) => {
        try {
            let params = JSON.parse(JSON.stringify(data)); //clear null

            params.dataIni = dayjs(
                params.date[0] ? params.date[0] : null,
            ).format("YYYY-MM-DD");
            params.dataFim = dayjs(
                params.date[1] ? params.date[1] : null,
            ).format("YYYY-MM-DD");
            delete params.date;

            if (params.data_vencimento) {
                params.data_vencimento =
                    dayjs(params.data_vencimento).format("YYYY-MM") + "-10";
            }

            let searchParams = new URLSearchParams(params);
            searchParams = searchParams.toString();
            setParamsEXCEL(searchParams);

            setLoading(true);
            let result = await fetch(
                config[process.env.NODE_ENV].url +
                    `/adicionais/relatorios/trabalhadores?${searchParams}`,
                {
                    method: "GET",
                    headers: getBasicAuthHeaders(),
                },
            );

            if (!result.ok) {
                throw await result.json();
            }

            result = await result.json();

            setDataSource(result.content);
            setHasSearched(true); // Sinaliza que busca foi realizada
        } catch (e) {
            //mensagem de erro
            if (e.hasOwnProperty("message")) {
                message.error(e.message);
            } else {
                message.error("Erro em executar a chamada.");
            }
        } finally {
            setLoading(false);
        }
    };

    const downloadExcelBlob = async (url) => {
        try {
            setLoadingExcel(true);
            let resp = await fetch(url, {
                method: "GET",
                headers: getBasicAuthHeaders(),
            });

            resp = await resp.blob();

            if (!resp.message) {
                setLoadingExcel(false);
                let url = window.URL.createObjectURL(resp);
                let a = document.createElement("a");
                a.href = encodeURI(url);
                a.download = "RELATORIO_ADIC_TRABALHADORES.xlsx";
                document.body.appendChild(a); // we need to append the element to the dom -> otherwise it will not work in firefox
                a.click();
                a.remove();
            } else {
                setLoadingExcel(false);
                message.error(resp.message);
            }
        } catch (e) {
            setLoadingExcel(false);
            message.error("Erro na chamada de arquivo");
        }
    };

    const formSearch = () => {
        return (
            <Card
                title={
                    <Space>
                        <Icons.SearchOutlined />
                        <span>Filtros de Pesquisa</span>
                    </Space>
                }
                style={{ marginBottom: 24 }}
                bodyStyle={{ padding: "20px 24px" }}
            >
                <Form
                    layout="vertical"
                    form={form}
                    onFinish={callSearchForm}
                    onValuesChange={(changedValues, allValues) => {
                        const { date, adic } = allValues;

                        // Valida se campos obrigatórios estão preenchidos
                        if (
                            date &&
                            date.length === 2 &&
                            adic &&
                            adic.length > 0
                        ) {
                            setFormValid(true);
                        } else {
                            setFormValid(false);
                        }
                    }}
                >
                    <Row gutter={[16, 16]}>
                        {/* Data de Pagamento */}
                        <Col xs={24} sm={12} md={6} lg={6}>
                            <FormItem
                                name="date"
                                label={
                                    <Space>
                                        <Icons.CalendarOutlined />
                                        <span>Data de Pagamento</span>
                                    </Space>
                                }
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            "Selecione o período de pagamento",
                                    },
                                ]}
                            >
                                <RangePicker
                                    locale={ptBR}
                                    disabledDate={(current) => {
                                        return (
                                            current &&
                                            current > dayjs().endOf("day")
                                        );
                                    }}
                                    style={{ width: "100%" }}
                                    showToday={true}
                                    format="DD/MM/YYYY"
                                    placeholder={["Data inicial", "Data final"]}
                                    size="large"
                                    allowClear
                                    separator="até"
                                />
                            </FormItem>
                        </Col>

                        {/* Data de Vencimento */}
                        <Col xs={24} sm={12} md={6} lg={6}>
                            <FormItem
                                name="data_vencimento"
                                label={
                                    <Space>
                                        <Icons.CalendarOutlined />
                                        <span>Data de Vencimento</span>
                                    </Space>
                                }
                            >
                                <DatePicker
                                    locale={ptBR}
                                    picker="month"
                                    disabledDate={(current) => {
                                        return (
                                            current &&
                                            current > dayjs().endOf("day")
                                        );
                                    }}
                                    style={{ width: "100%" }}
                                    showToday={true}
                                    format="MM/YYYY"
                                    placeholder="Selecione o mês"
                                    size="large"
                                    allowClear
                                />
                            </FormItem>
                        </Col>

                        {/* Adicional */}
                        <Col xs={24} sm={12} md={6} lg={6}>
                            <FormItem
                                name="adic"
                                label={
                                    <Space>
                                        <Icons.TagsOutlined />
                                        <span>Adicional</span>
                                    </Space>
                                }
                                rules={[
                                    {
                                        required: true,
                                        message:
                                            "Selecione pelo menos um adicional",
                                    },
                                ]}
                            >
                                <Select
                                    mode="multiple"
                                    placeholder="Selecione os adicionais"
                                    options={adic}
                                    onChange={(vls) => {
                                        setAdicArr(vls);
                                    }}
                                    showSearch
                                    optionFilterProp="label"
                                    allowClear
                                    size="large"
                                    notFoundContent="Nenhum adicional encontrado"
                                />
                            </FormItem>
                        </Col>

                        {/* Coluna de Botões */}
                        <Col xs={24} sm={12} md={6} lg={6}>
                            <FormItem label=" " colon={false}>
                                <Space
                                    direction="vertical"
                                    style={{ width: "100%" }}
                                    size="middle"
                                >
                                    {/* Botão Buscar */}
                                    <Button
                                        type="primary"
                                        htmlType="submit"
                                        size="large"
                                        disabled={!formValid || loading}
                                        loading={loading}
                                        icon={<Icons.SearchOutlined />}
                                        style={{ width: "100%" }}
                                    >
                                        BUSCAR
                                    </Button>

                                    {/* Botão Download Excel */}
                                    <Button
                                        type="default"
                                        size="large"
                                        disabled={
                                            !hasSearched ||
                                            !paramsEXCEL ||
                                            loadingExcel
                                        }
                                        loading={loadingExcel}
                                        icon={<Icons.FileExcelOutlined />}
                                        style={{ width: "100%" }}
                                        onClick={() =>
                                            downloadExcelBlob(
                                                `${config[process.env.NODE_ENV].url}/adicionais/relatorios/trabalhadores?${paramsEXCEL}&excel=true`,
                                            )
                                        }
                                    >
                                        DOWNLOAD XLSX
                                    </Button>
                                </Space>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            </Card>
        );
    };

    const [pageSize, setPageSize] = useState(50);
    const tableContent = () => {
        let columns = [
            {
                title: <small>Tipo</small>,
                dataIndex: "tipo",
                key: "tipo",
                ...getColumnSearchProps("tipo"),
                sorter: (a, b) => a.tipo.trim().localeCompare(b.tipo.trim()),
            },

            {
                title: <small>CPF</small>,
                dataIndex: "cpf",
                key: "cpf",
                width: 120,
                ...getColumnSearchProps("cpf"),
                sorter: (a, b) => a.cpf - b.cpf,
                render: (data) => {
                    return mask(data);
                },
            },
            {
                title: <small>NOME</small>,
                dataIndex: "nome",
                key: "nome",
                width: "auto",
                ...getColumnSearchProps("nome"),
                sorter: (a, b) => a.nome.trim().localeCompare(b.nome.trim()),
                render: (data) => {
                    return data;
                },
            },

            {
                title: <small>Sexo</small>,
                dataIndex: "sexo",
                ...getColumnSearchProps("sexo"),
                sorter: (a, b) => a.sexo.trim().localeCompare(b.sexo.trim()),
                key: "sexo",
            },

            {
                title: <small>Nasc.</small>,
                dataIndex: "nascimento",
                ...getColumnSearchProps("nascimento"),
                sorter: (a, b) =>
                    dayjs(a.nascimento).valueOf() -
                    dayjs(b.nascimento).valueOf(),
                key: "nascimento",
                render: (data) => {
                    return data ? mask(data, "date") : "-";
                },
            },
            {
                title: <small>Admi.</small>,
                dataIndex: "admissao",
                ...getColumnSearchProps("admissao"),
                sorter: (a, b) =>
                    dayjs(a.admissao).valueOf() - dayjs(b.admissao).valueOf(),
                key: "admissao",
                render: (data) => {
                    return data ? mask(data, "date") : "-";
                },
            },

            {
                title: <small>Razão Social</small>,
                dataIndex: "razao_social",
                ...getColumnSearchProps("razao_social"),
                sorter: (a, b) =>
                    a.razao_social.trim().localeCompare(b.razao_social.trim()),
                key: "razao_social",
            },

            {
                title: <small>CNPJ.</small>,
                dataIndex: "cnpj",
                ...getColumnSearchProps("cnpj"),
                sorter: (a, b) =>
                    dayjs(a.cnpj).valueOf() - dayjs(b.cnpj).valueOf(),
                key: "cnpj",
                render: (data) => {
                    return mask(data);
                },
            },

            {
                title: <small>CEP</small>,
                dataIndex: "cep",
                ...getColumnSearchProps("cep"),
                sorter: (a, b) => a.cep - b.cep,
                key: "cep",
                render: (data) => {
                    return mask(data, "cep");
                },
            },

            {
                title: <small>Endereço</small>,
                dataIndex: "endereco",
                ...getColumnSearchProps("endereco"),
                sorter: (a, b) =>
                    a.endereco.trim().localeCompare(b.endereco.trim()),
                key: "endereco",
            },

            {
                title: <small>Núm.</small>,
                dataIndex: "numero",
                key: "numero",
                width: 155,
                ...getColumnSearchProps("numero"),
                sorter: (a, b) => a.numero - b.numero,
                render: (data) => {
                    return data;
                },
            },

            {
                title: <small>Bairro</small>,
                dataIndex: "bairro",
                ...getColumnSearchProps("bairro"),
                sorter: (a, b) =>
                    a.bairro.trim().localeCompare(b.bairro.trim()),
                key: "bairro",
            },

            {
                title: <small>Cidade</small>,
                dataIndex: "cidade",
                ...getColumnSearchProps("cidade"),
                sorter: (a, b) =>
                    a.cidade.trim().localeCompare(b.cidade.trim()),
                key: "cidade",
            },

            {
                title: <small>Estado</small>,
                dataIndex: "estado",
                ...getColumnSearchProps("estado"),
                sorter: (a, b) =>
                    a.estado.trim().localeCompare(b.estado.trim()),
                key: "estado",
            },

            {
                title: <small>Complemento</small>,
                dataIndex: "complemento",
                ...getColumnSearchProps("complemento"),
                sorter: (a, b) =>
                    a.complemento.trim().localeCompare(b.complemento.trim()),
                key: "complemento",
            },

            {
                title: <small>Plano</small>,
                dataIndex: "plano",
                ...getColumnSearchProps("plano"),
                sorter: (a, b) => a.plano.trim().localeCompare(b.plano.trim()),
                key: "plano",
            },

            {
                title: <small>Placa.</small>,
                dataIndex: "placa",
                key: "placa",
                ...getColumnSearchProps("placa"),
                sorter: (a, b) => a.placa - b.placa,
            },

            {
                title: <small>Vencimento</small>,
                dataIndex: "data_vencimento",
                ...getColumnSearchProps("data_vencimento"),
                sorter: (a, b) =>
                    dayjs(a.data_vencimento).valueOf() -
                    dayjs(b.data_vencimento).valueOf(),
                key: "data_vencimento",
                render: (data) => {
                    return data ? mask(data, "date") : "-";
                },
            },
            {
                title: <small>Pagamento</small>,
                dataIndex: "data_pagamento",
                ...getColumnSearchProps("data_pagamento"),
                sorter: (a, b) =>
                    dayjs(a.data_pagamento).valueOf() -
                    dayjs(b.data_pagamento).valueOf(),
                key: "data_pagamento",
                render: (data) => {
                    return data ? mask(data, "date") : "-";
                },
            },
            {
                title: <small>Nosso Num.</small>,
                dataIndex: "nosso_numero",
                key: "nosso_numero",
                ...getColumnSearchProps("nosso_numero"),
                sorter: (a, b) => a.nosso_numero - b.nosso_numero,
                render: (data) => {
                    return data;
                },
            },

            {
                title: <small>Status</small>,
                dataIndex: "status",
                ...getColumnSearchProps("status"),
                sorter: (a, b) =>
                    a.status.trim().localeCompare(b.status.trim()),
                key: "status",
            },

            {
                title: <small>Mãe dependente</small>,
                dataIndex: "mae_dependente",
                ...getColumnSearchProps("mae_dependente"),
                sorter: (a, b) =>
                    a.mae_dependente
                        .trim()
                        .localeCompare(b.mae_dependente.trim()),
                key: "mae_dependente",
            },

            {
                title: <small>Filiação</small>,
                dataIndex: "filiacao",
                ...getColumnSearchProps("filiacao"),
                sorter: (a, b) =>
                    a.filiacao.trim().localeCompare(b.filiacao.trim()),
                key: "filiacao",
            },

            {
                title: <small>CPF Trab.</small>,
                dataIndex: "cpf_trabalhador",
                key: "cpf_trabalhador",
                ...getColumnSearchProps("cpf_trabalhador"),
                sorter: (a, b) => a.cpf_trabalhador - b.cpf_trabalhador,
                render: (data) => {
                    return mask(data);
                },
            },

            {
                title: <small>Nome Tra,</small>,
                dataIndex: "nome_trabalhador",
                ...getColumnSearchProps("nome_trabalhador"),
                sorter: (a, b) =>
                    a.nome_trabalhador
                        .trim()
                        .localeCompare(b.nome_trabalhador.trim()),
                key: "nome_trabalhador",
            },
        ];
        return (
            <Row>
                <Col sm={24} md={24} lg={24}>
                    <Table
                        rowKey={() => {
                            return "linha_" + Math.random();
                        }}
                        columns={columns}
                        scroll={{ x: 400 }}
                        dataSource={dataSource}
                        pagination={{
                            hideOnSinglePage: true,
                            showTotal: () => (
                                <span>
                                    Total <b>{dataSource.length}</b>{" "}
                                    Trabalhadores
                                </span>
                            ),
                            pageSize: pageSize,
                            pageSizeOptions: [20, 50, 100],
                            onShowSizeChange: (current, pageSize) => {
                                // console.log(current, pageSize);
                                setPageSize(pageSize);
                            },
                        }}
                    />
                </Col>
            </Row>
        );
    };

    return (
        <>
            {/* Header Section */}
            <Card
                style={{ marginBottom: 24 }}
                bodyStyle={{ padding: "20px 24px" }}
            >
                <Row align="middle" justify="space-between">
                    <Col>
                        <Title
                            level={2}
                            style={{ margin: 0, color: "#1890ff" }}
                        >
                            <Icons.TeamOutlined style={{ marginRight: 8 }} />
                            Relatório de Trabalhadores
                        </Title>
                        <Text type="secondary" style={{ fontSize: "14px" }}>
                            Lista completa de trabalhadores com informações
                            detalhadas de CPF, endereço, plano, vencimento e
                            status de pagamento.
                        </Text>
                    </Col>
                </Row>
            </Card>

            {formSearch()}

            <Spin spinning={loading}>
                {dataSource.length > 0 && (
                    <>
                        <Divider />
                        {tableContent()}
                    </>
                )}
            </Spin>

            {/* Empty state */}
            {!loading && dataSource.length === 0 && (
                <Card
                    style={{
                        textAlign: "center",
                        padding: "40px 20px",
                        marginTop: 16,
                    }}
                >
                    <div style={{ color: "#999" }}>
                        <Icons.SearchOutlined
                            style={{
                                fontSize: "48px",
                                marginBottom: "16px",
                            }}
                        />
                        <Title level={4} type="secondary">
                            Configure os filtros e clique em "BUSCAR"
                        </Title>
                        <Text type="secondary">
                            Selecione o período de pagamento e os adicionais
                            para visualizar os dados dos trabalhadores
                        </Text>
                    </div>
                </Card>
            )}
        </>
    );
};

const mapStateToProps = (state) => {
    return {
        user: state.user,
    };
};

export default connect(mapStateToProps)(Adicionais);
